'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _utils = require('../utils');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var isTicking = false;
  var lastKnownY = window.pageYOffset;
  var defaultScale = '1.1';

  var images = context.getElements('.' + context.className + '_Image').map(function (el) {
    return {
      el: el,
      scale: el.dataset.scale || defaultScale
    };
  });

  moveParallaxImage();

  window.addEventListener('scroll', onScroll);

  function onScroll() {
    lastKnownY = window.pageYOffset;

    requestTick();
  }

  function requestTick() {
    if (!isTicking) requestAnimationFrame(moveParallaxImage);

    // If a rAF is already queued we don't want to call another one
    isTicking = true;
  }

  function moveParallaxImage() {
    // Reset the tick so we can capture the next onScroll
    isTicking = false;

    images.forEach(function (image) {
      var el = image.el,
          scale = image.scale;

      if (el.offsetParent === null) return;

      var actualImageHeight = Math.round(el.offsetHeight * parseFloat(scale));
      var heightDifference = actualImageHeight - el.offsetHeight;

      var imageStartsParallaxing = (0, _utils.getOffsetTop)(el) - window.innerHeight;
      var imageEndsParallaxing = imageStartsParallaxing + window.innerHeight + el.offsetHeight;
      var totalScrollAmount = imageEndsParallaxing - imageStartsParallaxing;

      if (lastKnownY < imageStartsParallaxing) {
        el.style.transform = 'translateY(-' + heightDifference / 2 + 'px) scale(' + scale + ')';

        return;
      }

      if (lastKnownY > imageEndsParallaxing) {
        el.style.transform = 'translateY(' + heightDifference / 2 + 'px) scale(' + scale + ')';

        return;
      }

      var scrollYAsAPercentageOfJourney = (lastKnownY - imageStartsParallaxing) / totalScrollAmount;
      var transformAmount = heightDifference * scrollYAsAPercentageOfJourney - heightDifference / 2;

      el.style.transform = 'translateY(' + transformAmount + 'px) scale(' + scale + ')';
    });
  }
}